import { makeStyles } from '@material-ui/core/styles';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PRIMARY_COLOR } from 'Config';
import React, { useState } from 'react';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        borderRadius: '3px',
        width: '100%',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const LapuLoadingIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg width="36" height="36" viewBox="0 0 512 512">
                        <g id="Layer_1" />
                        <g id="Layer_2">
                            <g>
                                <path
                                    className={colorNonSelected}
                                    d="M446.6,27.5H172.03c-11.1,0-21.6,4.84-28.81,13.28L48.12,152.03c-5.86,6.86-9.09,15.6-9.09,24.63V446.6    c0,20.9,17,37.9,37.9,37.9H446.6c20.9,0,37.9-17,37.9-37.9V65.4C484.5,44.5,467.5,27.5,446.6,27.5z M452.5,446.6    c0,3.26-2.65,5.9-5.9,5.9H76.94c-3.26,0-5.9-2.65-5.9-5.9V176.66c0-1.41,0.5-2.77,1.42-3.84l95.09-111.25    c1.12-1.31,2.76-2.07,4.49-2.07H446.6c3.26,0,5.9,2.65,5.9,5.9V446.6z"
                                />
                                <path
                                    className={colorSelected}
                                    d="M221.34,102.79h-51.15c-8.84,0-16,7.16-16,16v74.04c0,8.84,7.16,16,16,16h51.15c8.84,0,16-7.16,16-16v-74.04    C237.34,109.95,230.17,102.79,221.34,102.79z M205.34,176.83h-19.15v-42.04h19.15V176.83z"
                                />
                                <path
                                    className={colorSelected}
                                    d="M317.3,102.79h-51.15c-8.84,0-16,7.16-16,16v74.04c0,8.84,7.16,16,16,16h51.15c8.84,0,16-7.16,16-16v-74.04    C333.3,109.95,326.13,102.79,317.3,102.79z M301.3,176.83h-19.15v-42.04h19.15V176.83z"
                                />
                                <path
                                    className={colorSelected}
                                    d="M413.25,102.79h-51.15c-8.84,0-16,7.16-16,16v74.04c0,8.84,7.16,16,16,16h51.15c8.84,0,16-7.16,16-16v-74.04    C429.25,109.95,422.09,102.79,413.25,102.79z M397.25,176.83h-19.15v-42.04h19.15V176.83z"
                                />
                            </g>
                        </g>
                    </svg>
                </p>
                <h6>Lapu Loading</h6>
            </div>
        </>
    );
};

export default LapuLoadingIcon;
